import React from "react";
import { Typography, Form, Select, Row, Col, message } from "antd";
import { StyledPrimaryButton } from "./styles";
import { DownOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { putSettings } from "../../../Redux/Slice/UserSlice";
const { Title, Text } = Typography;
const { Option } = Select;

export const UserConfig = () => {
  const [settingForm] = Form.useForm();
  // const [selectedImage, setSelectedImage] = useState(null);
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("General");
  const { userData } = useSelector((state: any) => state.user);
  const [messageApi, contextHolder] = message.useMessage();
  const { newsSources, newsGenres } = useSelector((state: any) => state.news);

  const error = () => {
    messageApi.open({
      type: "error",
      content: "Values cannot be negative",
    });
  };

  useEffect(() => {
    if (userData?.paragraphs) {
      settingForm.setFieldsValue({
        ...settingForm.getFieldsValue(),
        genres: userData?.genres,
        sources: userData?.sources,
        paragraphs: userData?.paragraphs,
        words: userData?.words,
      });
    }
  }, [userData]);

  // const handleSaveClick = () => {
  //   const values = {
  //     image: selectedImage,
  //   };
  //   if (selectedImage) {
  //     dispatch(videoConfig(values));
  //   } else {
  //   }
  // };

  // function normFile(e: any) {
  //   if (Array.isArray(e)) {
  //     return e;
  //   }
  //   return e && e.fileList;
  // }

  // function handleFileUpload(e: React.ChangeEvent<HTMLInputElement>) {
  //   const file = e.target.files && e.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setSelectedImage(reader.result as string);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // }

  const handleSettings = () => {
    const settingValues = settingForm.getFieldsValue([
      "genres",
      "sources",
      "paragraphs",
      "words",
    ]);
    // Convert paragraphs and words to integers
    const paragraphs = parseInt(settingValues.paragraphs, 10);
    const words = parseInt(settingValues.words, 10);

    if (paragraphs < 0 || words < 0) {
      error();

      return;
    }

    const settingPayload = {
      email: userData?.email,
      genres: settingValues.genres,
      sources: settingValues.sources,
      paragraphs: paragraphs, // Add the converted values to the payload
      words: words,
    };
    dispatch(putSettings({ ...settingPayload }));
  };

  return (
    <Row justify={"center"} style={{ marginTop: "10px", padding: "0px" }}>
      <Col span={24} lg={20}>
        <Content style={{ backgroundColor: "white", padding: "20px" }}>
          <Title level={3} style={{ marginBottom: "10px" }}>
            User Settings
          </Title>
          <Text>Select the default Sources and Genres for your News Page</Text>

          <Content>
            <Form
              form={settingForm}
              style={{ marginTop: "20px" }}
              layout="vertical"
            >
              <Form.Item label="Select Sources" name="sources">
                <Select
                  placeholder="Source"
                  suffixIcon={<DownOutlined />}
                  mode="multiple"
                >
                  {newsGenres?.genres.map((genre) => (
                    <Option value={genre}>{genre}</Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item label="Select Genre" name="genres">
                <Select
                  placeholder="Genre"
                  suffixIcon={<DownOutlined />}
                  mode="multiple"
                >
                  {newsSources?.sources.map((source) => (
                    <Option value={source}>{source}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Form>
          </Content>
          <Content style={{ marginTop: "10px" }}>
            {contextHolder}
            <StyledPrimaryButton
              style={{ width: "100%" }}
              type="primary"
              onClick={handleSettings}
            >
              Save
            </StyledPrimaryButton>
          </Content>
        </Content>
      </Col>
    </Row>
  );
};

export default UserConfig;
